
import { mergeMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { ScrAuthenticationService } from './authentication.service';
import { ScrEnvironment } from 'src/environments/environment';

/**
* This HTTP interceptor inserts the Authorization header into outgoing HTTP requests.
* The value of the header is the JWT contained in the user's Cognito user session (if it exists).
* In prior versions if the library, we used the Auth0 library to perform this function which
* pulled the header value from a local storage value.
*/

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor(private environment: ScrEnvironment, private injector: Injector) {
  }

  /**
  * Intercept the HTTP Request and insert Authorization header.
  * @param req - http request to insert Authorization header into
  * @param next - next handler
  */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // don't bother on an OPTIONS request.
    if (req.method === 'OPTIONS') {
      return next.handle(req);
    }

    // console.debug('with credentials is ' + req.withCredentials);

    const svc = this.injector.get(ScrAuthenticationService);

    const authState = svc.getAuthState();
    if (!authState && req.withCredentials) {
      // let it fail on the server and the user will get a message.
      console.warn('no auth state but credentials required');
    }
    if ((!authState) || (req.withCredentials === false)) {
      const req2 = req.clone({
        setHeaders: {
          'X-Api-Key': this.environment.api.scr.apikey
        }
      });
      return next.handle(req2);
    }

    const promise = svc.getIdToken();
    return from(promise).pipe(mergeMap(idToken => {
      let req2;
      if (idToken) {
        req2 = req.clone({
          withCredentials: false,
          setHeaders: {
            Authorization: idToken
          }
        });
      }
      else {
        req2 = req.clone({
          withCredentials: false,
          setHeaders: {
            'X-Api-Key': this.environment.api.scr.apikey
          }
        });
      }
      return next.handle(req2);
    }));
  }
}
